<template>
  <div class="root">
    <div class="top">套餐升级</div>
    <div class="package-list" v-if="packagelist && packagelist.length > 0">
      <div class="package-item" v-for="(item,index) in packagelist" :key="index" :class="'c'+nowPackage.net+'-'+item.net">
        <div class="circle" @click="checked=index"><span v-if="checked === index">√</span></div>
        <div class="org">
          <div class="price">{{nowPackage.price}}</div>
          <div>{{nowPackage.title}}</div>
        </div>
        <img :src="img['img'+nowPackage.net+item.net]" class="jt" />
        <div class="org">
          <div class="price">{{item.price}}</div>
          <div>{{item.title}}</div>
        </div>
        <div class="btn">
          <div class="price"><span class="yen">&yen;</span><span>{{item.diff}}</span></div>
          <div class="submit" @click="submit(item)">升级购买</div>
        </div>
        <img :src="bimg['bimg'+nowPackage.net+item.net]" class="bg" />
      </div>
    </div>

    <div class="package-list" v-if="arr && arr.length > 0">
      <div class="package-item c2-3" v-for="(item,index) in arr" :key="index">
        <div class="circle" @click="checked=index"><span v-if="checked === index">√</span></div>
        <div class="org">
          <div class="price">{{nowPackage.price}}</div>
          <div>{{nowPackage.packagename}}</div>
        </div>
        <img :src="img['img23']" class="jt" />
        <div class="org">
          <div class="price">{{item.price}}</div>
          <div style="white-space: nowrap;overflow-x: hidden;">{{item.title}}</div>
        </div>
        <div class="btn">
          <div class="price"><span class="yen">&yen;</span><span>{{item.diff}}</span></div>
          <div class="submit" @click="submitpackage(item)">升级购买</div>
        </div>
      </div>
    </div>

    <div class="tips">
      <div class="tp-title">温馨提示</div>
      <ul class="tp-content">
        <li>网络服务由当地优质运营商提供，安全靠谱</li>
        <li>购买后 30 天之内随时启用，有效期将从启用后开始计算，每 24 小时计为1天，一经启用，无法暂停计时</li>
        <li>购买后使用 30 天以内，可在公众号联系客服取消订单在海岛、隧道、山区、高速公路、沙漠等偏远地区，受限于运营商网络覆盖，可能会出现信号较弱和信号丢失的情况</li>
        <li>开启热点共享时，建议关闭接入手机的同步、备份等功.能，避免套餐流量消耗过快</li>
      </ul>
    </div>
  </div>
</template>
<script>
  import img13 from '@/assets/newimg/images/1-3_03.png'
  import img23 from '@/assets/newimg/images/2-3_03.png'
  import img12 from '@/assets/newimg/images/1-2_03.png'
  import bimg12 from '@/assets/newimg/images/b1-2_03.png'
  import bimg13 from '@/assets/newimg/images/b1-3_03.png'
  import bimg23 from '@/assets/newimg/images/b2-3_03.png'



export default {
  name: "recharge",
  data() {
    return {
      checked:null,
      img:{
        img13,
        img23,
        img12
      },bimg:{
        bimg13,
        bimg23,
        bimg12
      },
      iccid: 1,
      operator:{},
      packagelist:[],
      nowPackage:{},
      arr:[]
    }
  },
  methods:{
    getPackagelist(){
      this.fetchData("/package/shengji",{iccid:this.iccid},res=>{
        this.packagelist = res.data.list;
        this.arr = res.data.arr;
        this.nowPackage =res.data.nowpackage
      })
    },
    submit(item){
      this.$toast.loading({duration:0,forbidClick:true,message:'正在下单'});
      const postData = {
        packageID:this.nowPackage.id,
        target:item.target,
        price:item.diff,
        iccid:this.iccid,
        newPackageID:item.newPackageID
      }
      this.fetchData("/order/shengji",postData,res=>{
        this.$toast.clear();
        if(res.code){
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', res.data,
            (res)=>{
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                this.$toast('支付成功');
                this.$router.push({name:'index',query:{iccid:this.iccid}})
              }
            }
          );
        }else{

          if(res.url){
            this.$dialog.confirm({
              title: '提示',
              message: res.msg
            }).then(() => {
              window.location.href = res.url
            }).catch(() => {

            });
          }else {
            if (res.msg.indexOf('appid') !== -1 && res.msg.indexOf('openid') !== -1) {
              this.$toast('登录失效，请尝试重新进入查询')
              sessionStorage.clear()
            } else {
              this.$toast(res.msg)
            }
          }
        }
      })

    },submitpackage(item){
      this.$toast.loading({duration:0,forbidClick:true,message:'正在下单'});
      const postData = {
        packageID:this.nowPackage.id,
        price:item.diff,
        iccid:this.iccid,
        noworderid:item.orderID,
        newPackageID:item.newPackageID
      }
      this.fetchData("/order/shengjipackage",postData,res=>{
        this.$toast.clear();
        if(res.code){
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', res.data,
            (res)=>{
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                this.$toast('支付成功');
                this.$router.push({name:'index',query:{iccid:this.iccid}})
              }
            }
          );
        }else{

          if(res.url){
            this.$dialog.confirm({
              title: '提示',
              message: res.msg
            }).then(() => {
              window.location.href = res.url
            }).catch(() => {

            });
          }else {
            if (res.msg.indexOf('appid') !== -1 && res.msg.indexOf('openid') !== -1) {
              this.$toast('登录失效，请尝试重新进入查询')
              sessionStorage.clear()
            } else {
              this.$toast(res.msg)
            }
          }
        }
      })

    }

  },
  created() {
    this.iccid = this.$route.query.iccid
    this.fetchData("/card/cardoperator",{iccid:this.iccid},res=>{
      this.operator = res.data
    })
    this.getPackagelist()
  }
}
</script>
<style scoped lang="scss">
.root {
  height: inherit;
  font-size: 0;
  background: -webkit-gradient(linear, left top, right  bottom, from(#FF9090FF), to(#F05864FF));
  background: linear-gradient(135deg, #FF9090FF,#F05864FF);
  overflow-y: scroll;
  .package-list{
    width: 7rem;
    margin: .2rem auto;
    .package-item.c1-2{
      color: #0b8ed4;
      .circle{
        border-color: #0b8ed4;
        color: #0b8ed4;
      }
      .btn{
        .submit{
          background: #0b8ed4;
        }
        .price{
          .yen{
            border: 1px solid #0b8ed4;
          }
        }
      }
    }
    .package-item.c1-3{
      color: #F05864FF;
      .circle{
        border-color: #F05864FF;
        color: #F05864FF;
      }
      .btn{
        .submit{
          background: #F05864FF;
        }
        .price{
          .yen{
            border: 1px solid #F05864FF;
          }
        }
      }
    }
    .package-item.c2-3{
      color: #ff8a44;
      .circle{
        border-color: #ff8a44;
        color: #ff8a44;
      }
      .btn{
        .submit{
          background: #ff8a44;
        }
        .price{
          .yen{
            border: 1px solid #ff8a44;
          }
        }
      }
    }
    .package-item{
      width: 100%;
      height: 1.65rem;
      background: #fff;
      border-radius: .2rem;
      margin-bottom: .4rem;
      line-height: 1.65rem;
      /*display: flex*/;
      position: relative;
      .bg{
        height: 1.11rem;
        width: .64rem;
        position: absolute;
        right: 0;
        top: .27rem;
      }
      .btn{
        display: inline-block;
        margin-left: .6rem;
        text-align: center;
        font-size: 0;
        vertical-align: middle;
        line-height: 0;
        .submit{
          width: 1.1rem;
          height: .4rem;
          text-align: center;
          line-height: .4rem;
          margin-top: .06rem;
          color: #fff;
          font-size: .22rem;
          border-radius: .04rem;
        }
        .price{
          font-size: .36rem;
          display: inline-block;
          height: .4rem;
          line-height: .4rem;
          .yen{
            display: inline-block;
            width: .25rem;
            height: .25rem;
            font-size: .22rem;
            margin-top: -.08rem;
            vertical-align: middle;
            text-align: center;
            line-height: .25rem;
            border-radius: 100%;
            /*border: 1px solid #0b8ed4;*/
          }
        }
      }
      .circle{
        width: .38rem;
        height: .38rem;
        display: inline-block;
        border-radius: 100%;
        vertical-align: middle;
        margin-left: .4rem;
        border-width: 1px;
        border-style: solid;
        border-color:#0b8ed4 ;
        text-align: center;
        line-height: .38rem;
        span{
          font-size: .32rem;
          font-weight: bold;
        }
      }
      .org{
        display: inline-block;
        line-height: 1;
        margin-left: .3rem;
        text-align: center;
        vertical-align: middle;
        .price{
          font-size: .36rem;
          line-height: .24rem;
        }
        :last-child{
          font-size: .24rem;
          margin-top: .2rem;
          width: 1rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow-y: hidden;
        }
      }
      .jt{
        width: .84rem;
        vertical-align: middle;
        display: inline-block;
        margin-left: .32rem;
        padding-bottom: .42rem;
      }
    }
  }
  .tips{
    width: 6.2rem;
    margin: .4rem auto;
    color: #fff;
    .tp-title{
      font-size: .32rem;
    }
    .tp-content{
      margin-top: .26rem;
      margin-left: .32rem;
      li{
        line-height: .34rem;
        font-size: .26rem;
        margin-top: .1rem;
        list-style: square;
      }
    }
  }
  .top {
    font-size: .34rem;
    text-align: center;
    font-weight: bold;
    color: #fff;
    padding: .42rem 0 .4rem;
    background: #F05864;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/shengji.vue